 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"ApexLineChart":"ApexLineChart","ArcPieChart":"ArcPieChart","BaoAnalytics~CallMainContainer":"BaoAnalytics~CallMainContainer","BaoAnalytics":"BaoAnalytics","BaoDashboard~BaoItemList~CallSetup~PlaybookConfigurator~PlaybookItemList":"BaoDashboard~BaoItemList~CallSetup~PlaybookConfigurator~PlaybookItemList","BaoDashboard":"BaoDashboard","BaoValueConfigurator":"BaoValueConfigurator","BarChart~HorizontalBarChart~LineChart":"BarChart~HorizontalBarChart~LineChart","BarChart":"BarChart","HorizontalBarChart":"HorizontalBarChart","LineChart":"LineChart","CallFeedback~CallList~CallMainContainer~CallSetup~CallWrapUp~CounterpartList~IntegrationsModule~Play~d10f507f":"CallFeedback~CallList~CallMainContainer~CallSetup~CallWrapUp~CounterpartList~IntegrationsModule~Play~d10f507f","CallList~CallMainContainer~CallSetup~CallWrapUp~printCallSummary":"CallList~CallMainContainer~CallSetup~CallWrapUp~printCallSummary","CallSetup":"CallSetup","CallFeedback~CallList~CallWrapUp~SharedCall~printCallSummary":"CallFeedback~CallList~CallWrapUp~SharedCall~printCallSummary","CallFeedback":"CallFeedback","CallMainContainer":"CallMainContainer","CounterpartList":"CounterpartList","IntegrationsModule":"IntegrationsModule","RichTextEditor":"RichTextEditor","MainContainer~PlaybookConfigurator~PlaybookList~TeamModule":"MainContainer~PlaybookConfigurator~PlaybookList~TeamModule","PlaybookConfigurator":"PlaybookConfigurator","PlaybookItemList~PlaybookList":"PlaybookItemList~PlaybookList","PlaybookItemList":"PlaybookItemList","CallList":"CallList","CallWrapUp":"CallWrapUp","printCallSummary":"printCallSummary","SharedCall":"SharedCall","CoPilot":"CoPilot","CoPilotCreate":"CoPilotCreate","CoPilotHome":"CoPilotHome","DRFCharts":"DRFCharts","Dynamics365ResourceSelector":"Dynamics365ResourceSelector","HeatMapChart":"HeatMapChart","LoginView":"LoginView","MainContainer":"MainContainer","PlaybookList":"PlaybookList","TeamModule":"TeamModule","OauthLoginHandler":"OauthLoginHandler","PasswordReset":"PasswordReset","PlentyMarketsLogin":"PlentyMarketsLogin","ResultItemConfigurator":"ResultItemConfigurator","Signout":"Signout","UserProfileDetails":"UserProfileDetails","VueCtkDateTimePicker":"VueCtkDateTimePicker","AnswerChoices":"AnswerChoices","BaoItemList":"BaoItemList","CrmEventCreator":"CrmEventCreator","CrmField":"CrmField","TaskCreator":"TaskCreator","ShortcutsModal":"ShortcutsModal","VuePasswordStrengthMeter":"VuePasswordStrengthMeter"}[chunkId]||chunkId) + "." + {"ApexLineChart":"7538bb48","ArcPieChart":"a87d351a","BaoAnalytics~CallMainContainer":"da8e36db","BaoAnalytics":"e7320f86","BaoDashboard~BaoItemList~CallSetup~PlaybookConfigurator~PlaybookItemList":"3abf4196","BaoDashboard":"908c5402","BaoValueConfigurator":"6efd97da","BarChart~HorizontalBarChart~LineChart":"4004646b","BarChart":"c5965bc9","HorizontalBarChart":"5f598e94","LineChart":"1ee016a4","CallFeedback~CallList~CallMainContainer~CallSetup~CallWrapUp~CounterpartList~IntegrationsModule~Play~d10f507f":"260f5532","CallList~CallMainContainer~CallSetup~CallWrapUp~printCallSummary":"70ec0205","CallSetup":"2886184a","CallFeedback~CallList~CallWrapUp~SharedCall~printCallSummary":"a1c19ebf","CallFeedback":"a590b82a","CallMainContainer":"e3776f25","CounterpartList":"c3150b02","IntegrationsModule":"a5b84b81","RichTextEditor":"ee40868b","MainContainer~PlaybookConfigurator~PlaybookList~TeamModule":"b3ac45c1","PlaybookConfigurator":"e695d49a","PlaybookItemList~PlaybookList":"f7937cd2","PlaybookItemList":"53b7af32","CallList":"d4d75546","CallWrapUp":"a2d755ed","printCallSummary":"b7c139a7","SharedCall":"a9fab398","CoPilot":"0422c1df","CoPilotCreate":"3ea875bc","CoPilotHome":"87854716","DRFCharts":"fe5b7e1b","Dynamics365ResourceSelector":"e390727c","HeatMapChart":"9012be49","LoginView":"0233242d","MainContainer":"66ba1602","PlaybookList":"2a1afe2c","TeamModule":"15e997cd","OauthLoginHandler":"8e07f534","PasswordReset":"f4fdda34","PlentyMarketsLogin":"10591167","ResultItemConfigurator":"aeadeb86","Signout":"58ee886c","UserProfileDetails":"c47fc4c9","chunk-2d216257":"69e90091","VueCtkDateTimePicker":"d215d39c","AnswerChoices":"331d34bf","BaoItemList":"e910ea77","CrmEventCreator":"d7597453","CrmField":"79f4d906","TaskCreator":"4aa60b7d","ShortcutsModal":"451d66f6","VuePasswordStrengthMeter":"8873c19b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"ArcPieChart":1,"BaoAnalytics~CallMainContainer":1,"BaoAnalytics":1,"BaoDashboard":1,"BaoValueConfigurator":1,"CallList~CallMainContainer~CallSetup~CallWrapUp~printCallSummary":1,"CallSetup":1,"CallFeedback~CallList~CallWrapUp~SharedCall~printCallSummary":1,"CallFeedback":1,"CallMainContainer":1,"CounterpartList":1,"IntegrationsModule":1,"RichTextEditor":1,"PlaybookConfigurator":1,"PlaybookItemList~PlaybookList":1,"PlaybookItemList":1,"CallList":1,"CallWrapUp":1,"printCallSummary":1,"SharedCall":1,"CoPilotCreate":1,"CoPilotHome":1,"DRFCharts":1,"Dynamics365ResourceSelector":1,"HeatMapChart":1,"LoginView":1,"MainContainer":1,"PlaybookList":1,"TeamModule":1,"PasswordReset":1,"PlentyMarketsLogin":1,"ResultItemConfigurator":1,"Signout":1,"UserProfileDetails":1,"AnswerChoices":1,"BaoItemList":1,"CrmField":1,"ShortcutsModal":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"ApexLineChart":"ApexLineChart","ArcPieChart":"ArcPieChart","BaoAnalytics~CallMainContainer":"BaoAnalytics~CallMainContainer","BaoAnalytics":"BaoAnalytics","BaoDashboard~BaoItemList~CallSetup~PlaybookConfigurator~PlaybookItemList":"BaoDashboard~BaoItemList~CallSetup~PlaybookConfigurator~PlaybookItemList","BaoDashboard":"BaoDashboard","BaoValueConfigurator":"BaoValueConfigurator","BarChart~HorizontalBarChart~LineChart":"BarChart~HorizontalBarChart~LineChart","BarChart":"BarChart","HorizontalBarChart":"HorizontalBarChart","LineChart":"LineChart","CallFeedback~CallList~CallMainContainer~CallSetup~CallWrapUp~CounterpartList~IntegrationsModule~Play~d10f507f":"CallFeedback~CallList~CallMainContainer~CallSetup~CallWrapUp~CounterpartList~IntegrationsModule~Play~d10f507f","CallList~CallMainContainer~CallSetup~CallWrapUp~printCallSummary":"CallList~CallMainContainer~CallSetup~CallWrapUp~printCallSummary","CallSetup":"CallSetup","CallFeedback~CallList~CallWrapUp~SharedCall~printCallSummary":"CallFeedback~CallList~CallWrapUp~SharedCall~printCallSummary","CallFeedback":"CallFeedback","CallMainContainer":"CallMainContainer","CounterpartList":"CounterpartList","IntegrationsModule":"IntegrationsModule","RichTextEditor":"RichTextEditor","MainContainer~PlaybookConfigurator~PlaybookList~TeamModule":"MainContainer~PlaybookConfigurator~PlaybookList~TeamModule","PlaybookConfigurator":"PlaybookConfigurator","PlaybookItemList~PlaybookList":"PlaybookItemList~PlaybookList","PlaybookItemList":"PlaybookItemList","CallList":"CallList","CallWrapUp":"CallWrapUp","printCallSummary":"printCallSummary","SharedCall":"SharedCall","CoPilot":"CoPilot","CoPilotCreate":"CoPilotCreate","CoPilotHome":"CoPilotHome","DRFCharts":"DRFCharts","Dynamics365ResourceSelector":"Dynamics365ResourceSelector","HeatMapChart":"HeatMapChart","LoginView":"LoginView","MainContainer":"MainContainer","PlaybookList":"PlaybookList","TeamModule":"TeamModule","OauthLoginHandler":"OauthLoginHandler","PasswordReset":"PasswordReset","PlentyMarketsLogin":"PlentyMarketsLogin","ResultItemConfigurator":"ResultItemConfigurator","Signout":"Signout","UserProfileDetails":"UserProfileDetails","VueCtkDateTimePicker":"VueCtkDateTimePicker","AnswerChoices":"AnswerChoices","BaoItemList":"BaoItemList","CrmEventCreator":"CrmEventCreator","CrmField":"CrmField","TaskCreator":"TaskCreator","ShortcutsModal":"ShortcutsModal","VuePasswordStrengthMeter":"VuePasswordStrengthMeter"}[chunkId]||chunkId) + "." + {"ApexLineChart":"31d6cfe0","ArcPieChart":"a2de5da0","BaoAnalytics~CallMainContainer":"25475ea7","BaoAnalytics":"128c19f1","BaoDashboard~BaoItemList~CallSetup~PlaybookConfigurator~PlaybookItemList":"31d6cfe0","BaoDashboard":"b3189f21","BaoValueConfigurator":"8c710d87","BarChart~HorizontalBarChart~LineChart":"31d6cfe0","BarChart":"31d6cfe0","HorizontalBarChart":"31d6cfe0","LineChart":"31d6cfe0","CallFeedback~CallList~CallMainContainer~CallSetup~CallWrapUp~CounterpartList~IntegrationsModule~Play~d10f507f":"31d6cfe0","CallList~CallMainContainer~CallSetup~CallWrapUp~printCallSummary":"9418d894","CallSetup":"4b935994","CallFeedback~CallList~CallWrapUp~SharedCall~printCallSummary":"53525eca","CallFeedback":"d49d7320","CallMainContainer":"e8402bd7","CounterpartList":"670f714e","IntegrationsModule":"044618dd","RichTextEditor":"02938014","MainContainer~PlaybookConfigurator~PlaybookList~TeamModule":"31d6cfe0","PlaybookConfigurator":"6717de48","PlaybookItemList~PlaybookList":"333a22c9","PlaybookItemList":"52ee9f12","CallList":"afb66d69","CallWrapUp":"2854afab","printCallSummary":"f8270cad","SharedCall":"05f31d44","CoPilot":"31d6cfe0","CoPilotCreate":"8031e7f4","CoPilotHome":"814e97c9","DRFCharts":"c60db10a","Dynamics365ResourceSelector":"730c9310","HeatMapChart":"1bf168a9","LoginView":"b74677ba","MainContainer":"c9cb256a","PlaybookList":"f472fdd4","TeamModule":"593819e7","OauthLoginHandler":"31d6cfe0","PasswordReset":"5c5169a4","PlentyMarketsLogin":"39951817","ResultItemConfigurator":"3a80d2bd","Signout":"e25bf0ca","UserProfileDetails":"18bf9f3d","chunk-2d216257":"31d6cfe0","VueCtkDateTimePicker":"31d6cfe0","AnswerChoices":"91fdd6be","BaoItemList":"c9e91256","CrmEventCreator":"31d6cfe0","CrmField":"e9d10daf","TaskCreator":"31d6cfe0","ShortcutsModal":"b3a8dda0","VuePasswordStrengthMeter":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
